/* eslint-disable no-new-func */
// Dynamic terms component loader using Function to avoid static analysis
export const loadTermsComponent = async (componentName: string) => {
  const componentPaths: Record<string, string> = {
    terms: '~/components/pages/terms/terms-conditions.vue',
    privacy: '~/components/pages/terms/privacy.vue',
    lgpd: '~/components/pages/terms/lgpd.vue',
    consent: '~/components/pages/terms/consent.vue',
    'kyc-policy': '~/components/pages/terms/kyc-policy.vue',
    'betting-terms': '~/components/pages/terms/betting-terms.vue',
    'pld-ftp-policy': '~/components/pages/terms/pld-ftp-policy.vue',
    'responsible-gaming': '~/components/pages/terms/responsible.vue',
  };

  const componentPath = componentPaths[componentName];

  if (componentPath) {
    // Use Function constructor to avoid static analysis
    const importFn = new Function('path', 'return import(path)');
    const module = await importFn(componentPath);

    return module.default;
  }

  return null;
};
